import React, { useEffect, useState } from "react";
import SavedMunis from "../components/SavedMunis";
import { UserAuth } from "../context/AuthContext";
import PlansScreen from "../components/PlansScreen";

const Account = () => {
  const { user } = UserAuth();

  return (
    <>
      <div className="w-full text-white">
        <img
          className="w-full h-[400px] object-cover"
          src={`./background.jpg`}
          alt="OFCTV Banner"
        ></img>

        <div className="bg-black/60  absolute top-0 left-0 w-full h-[400px]">
          <div className="absolute top-[20%] p-4 md:p-8"></div>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold pl-4 py-4">
          Hello, {user.email}
        </h1>
        <div>{/* <PlansScreen /> */}</div>
        <div>
          <h2 className="pl-4 py-2">
            See live and archived games on the{" "}
            <a className="text-blue-500" href="/">
              homepage
            </a>{" "}
            or view your saved favourites below
          </h2>
        </div>
        {
          <div>
            {" "}
            <SavedMunis />{" "}
          </div>
        }
      </div>
      <br></br>
    </>
  );
};

export default Account;
